import React from 'react';
import { Col, Row, ControlLabel } from 'react-bootstrap';
import { InfoLabel } from '../../../../../../common/components';
import { Link } from 'react-router';
import getStatus from '../../../../../../schemas/policy';
import Markdown from 'react-markdown';
import UserLabel from '../../../../../../common/components/UserLabel/UserLabel';
const getPolicyStatus = (status, quoteType) => {

  if (quoteType === 'mid term adjustment' && status === 'quote') {
    return 'awaiting approval';
  }

  return getStatus(status);
};
export const History = ({
  resource,
  applications,
  mtas,
  policy,
  broker,
  source,
  user,
  renewalPolicyApplications,
  isPolicy,
  campaignName,
}) => {
  const originalQuoteUser = resource?.metadata?.storage?.quote_originator;
  const issuedBy = isPolicy
    ? applications?.[0]?.attributes?.issued_by
    : resource.issued_by;
  const { first_name: userFirstName, last_name: userLastName, user_type: userType } =
    user?.data?.attributes ?? {};

  const mtaChanges  = resource?.metadata?.storage?.endorsements?.[0]?.content ?? resource?.metadata?.changes?.join(', ');
  return (
    <div>
      <Row>
        <Col sm={12} className="section-title">
          <h4>History</h4>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          {applications.length > 0 && (
            <InfoLabel
              labelSize={2}
              label="Quotes"
              value={applications.map((quote, i) => {
                return (
                  <span key={i}>
                    <Link to={'/policies/applications/' + quote.id} onlyActiveOnIndex>
                      {quote.attributes.quote_reference}{' '}
                    </Link>
                  </span>
                );
              })}
            />
          )}
          {renewalPolicyApplications.length > 0 && (
            <InfoLabel
              labelSize={2}
              label="Renewal Quote"
              value={renewalPolicyApplications.map((quote, i) => {
                return (
                  <span key={i}>
                    <Link to={'/policies/applications/' + quote.id} onlyActiveOnIndex>
                      {quote.attributes.quote_reference}{' '}
                    </Link>
                  </span>
                );
              })}
            />
          )}
          {mtas.length > 0 && (
            <Row>
              <Col sm={12}>
                <InfoLabel
                  labelSize={2}
                  label="Mid Term Adjustments"
                  value={mtas.map((mta, i) => {
                    return (
                      <span key={i}>
                        <Link to={'/policies/applications/' + mta.id} onlyActiveOnIndex>
                          {mta.attributes.quote_reference}
                          {', '}
                        </Link>
                      </span>
                    );
                  })}
                />
              </Col>
            </Row>
          )}
          {!!policy?.data?.attributes && (
            <Row>
              <Col sm={12}>
                <InfoLabel
                  labelSize={2}
                  label="Policy"
                  value={
                    <Link to={'/policies/issued/' + policy.data.id} onlyActiveOnIndex>
                      {`${policy.data.attributes.policy_number} (${getPolicyStatus(
                        policy.data.attributes.status,
                        resource?.quote_type,
                      )})`}
                    </Link>
                  }
                />
              </Col>
            </Row>
          )}

          {resource.quote_type === 'mid term adjustment' && (
            <Row>
              <Col sm={2}>
                <ControlLabel>Mid Term Adjustment</ControlLabel>
              </Col>
              <Col sm={10}>
                <div className={'endorsement-changes-info'}>
                  <Markdown
                    source={mtaChanges ?? ''}
                  />
                </div>
              </Col>
            </Row>
          )}

          <Row>
            <Col sm={6}>
              <InfoLabel
                label="Channel"
                value={resource?.channel_name}
                labelSize={4}
                wrapperClass={'clear-margin'}
              />
            </Col>
            {!!source?.data?.attributes?.name && (
              <Col sm={6}>
                <InfoLabel
                  label="Source"
                  value={source?.data?.attributes?.name ?? ''}
                  labelSize={4}
                />
              </Col>
            )}
          </Row>

          <Row>
            {!!broker?.data?.attributes?.broker_type && (
              <Col sm={6}>
                <InfoLabel
                  label={
                    broker?.data?.attributes?.broker_type === 'tracking'
                      ? 'Tracking Link'
                      : 'Broker'
                  }
                  value={broker?.data?.attributes?.name ?? ''}
                  labelSize={4}
                />
              </Col>
            )}
          </Row>

          <Row>
            <Col sm={6}>
              <InfoLabel label="Sales Agent" value={issuedBy || ''} labelSize={4} />

              <UserLabel
                userType={userType}
                userName={`${userFirstName ?? ''} ${userLastName ?? ''}`}
              />
            </Col>
            {/*        if originator set in metadata and user has permission to see users */}
            {!!originalQuoteUser && !!userType && (
              <Col sm={6}>
                <InfoLabel
                  label="Originating User"
                  value={`${originalQuoteUser?.first_name ??
                    ''}  ${originalQuoteUser?.last_name ?? ''}`}
                  labelSize={4}
                />
              </Col>
            )}
          </Row>
          {campaignName && (
            <Row>
              <Col sm={6}>
                <InfoLabel
                  label="Campaign Name"
                  value={campaignName ?? ''}
                  labelSize={4}
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>
      <div className="hr" />
    </div>
  );

};
export default History;
